import { ModalStore } from 'ui/base/modal/modal_store';
import { BooleanStore } from 'ui/base/input';
import { action, computed, observable } from 'mobx';
import { ORDERED_ACTIONS, Action } from 'assets/enums/actions/actions';

export class ActionStore {
  @observable.deep values: Record<Action, boolean>;
  workspace: Record<Action, BooleanStore>;

  modal: ModalStore;

  constructor(initial: Record<Action, boolean>) {
    this.values = {
      [Action.ALLOWED]: initial[Action.ALLOWED],
      [Action.BLOCKED]: initial[Action.BLOCKED],
    };

    this.workspace = {
      [Action.ALLOWED]: new BooleanStore(this.values[Action.ALLOWED]),
      [Action.BLOCKED]: new BooleanStore(this.values[Action.BLOCKED]),
    };

    this.modal = new ModalStore(false);
  }

  // This triggers a reload from the stored values to the workspace
  // This is best used before opening the modal
  @action.bound
  reloadWorkspace(): void {
    Object.entries(this.workspace).forEach(([dir, store]) => {
      store.value = this.values[dir as Action];
    });
  }

  // This triggers a commit to the workspace from the stored values
  // Best used before closing and saving the modal
  @action.bound
  commitWorkspace(): void {
    Object.entries(this.workspace).forEach(([dir, store]) => {
      this.values[dir as Action] = store.value;
    });
  }

  @computed get arrayValue(): Action[] {
    return ORDERED_ACTIONS.filter((dir) => this.values[dir] === true);
  }

  @computed get workspaceHasChecked(): boolean {
    return Object.values(this.workspace).some((store) => store.value);
  }
}
